// @owners { team: patients }
import { Icon } from '@alto/design-system';
import React from 'react';
import { ImageUploadListButton } from '~web/components/ImageUploadListButton';

export type UploadImageProps = {
  readonly loading: boolean;
  readonly onImageUpload: ({ userID, file }: { userID: number; file: File }) => void;
  readonly userID: number;
  readonly image?: string;
};

export const PhotoIDImageUploadModule = ({ loading, onImageUpload, userID, image = '' }: UploadImageProps) => {
  const handleCardFrontFileChange = (file: File) => {
    // Image upload needs a File
    onImageUpload({
      userID,
      file,
    });
  };

  return (
    <ImageUploadListButton
      name="photo-id"
      onUpload={handleCardFrontFileChange}
      source={image}
      loading={loading}
      rightIcon="chevronright-small"
      LeftContent={
        <Icon
          name="idcard"
          accessibilityLabel="Press to upload government issued photo ID"
        />
      }
    >
      Upload ID
    </ImageUploadListButton>
  );
};
